import React, {Fragment, useContext, useEffect, useState} from "react";
import {Button, Col, Container, FormGroup, Label, Media, Row} from "reactstrap";
import localized from "../../i18n";
import {Link, useNavigate} from "react-router-dom";
import {Formik} from "formik";
import Field from "../Field";
import axios from "axios";
import {handleError, showsuccesToast} from "../HandleError";
import {emailvalidate, strongPassword} from "../Field/validate";
import cookie from "../../utils/cookie";
import authContext from "../../AuthProvider/authContext";
import {getParams} from "../../utils/params";

const Login = () => {
    const navigate = useNavigate();
    const {getAuthenticatedUser,updateAuth} = useContext(authContext);
    const [togglePassword, setTogglePassword] = useState(false);
    const language = localStorage.getItem("lang");
    const login = (values, setSubmitting) => {
        setSubmitting(true);
        axios.post("/api/login", values)
            .then((response) => {
                setSubmitting(false);
                const token = response.data.data.token;
                showsuccesToast("Logged in successfully...");
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                cookie.save('jwt', token, {
                    path: '/',
                    days: 7,
                });
                getAuthenticatedUser(false)
            })
            .catch((err) => {
                 if(!err.response.data.verified && err.response.data.data !== null) {
                    {err.response.data &&
                    cookie.save('credentials', values.email, {path: '/',days: 1,})};
                    navigate("/verify-otp")
                     axios.post("/api/resend-otp", {email:values.email})
                         .then((res)=> {
                             const data = res.data.data.language
                             updateAuth({lang:data});
                             localStorage.setItem('lang', data)
                             localized.setLanguage(localStorage.getItem('lang'));
                             showsuccesToast(localized.otp_success_sent_successfully)
                         })
                         .catch((err)=>handleError(err));
                 } else {
                        handleError(err);
                 }
             setSubmitting(false);
        })
    }

    return (
        <Container fluid={true} className="p-0">
            <Row className="m-0">
                <Col xs="12" className="p-0">
                    <div className="login-card auth-login">
                        <div>
                            <div className="logo">
                                <Media
                                    className={"img-fluid for-light w-50"}
                                    src={`${require("../../assets/images/logo/logo.png")}`}
                                    alt={"logo image"}
                                />
                            </div>
                            <div className="login-main login-tab">
                                <Formik
                                    initialValues={{
                                        email: "",
                                        password: "",
                                    }}
                                    onSubmit={(values, {setSubmitting}) => login(values, setSubmitting)}
                                >
                                    {props => {
                                        const {handleSubmit, isSubmitting} = props;
                                        return (
                                            <form onSubmit={handleSubmit} className="theme-form">
                                                <Fragment>
                                                    <h2 className={"text-center"}> {localized.login_title} </h2>
                                                    <p className={"text-center"}>
                                                        {localized.login_email_password_instruction}
                                                    </p>
                                                </Fragment>
                                                <Field
                                                    label={localized.EmailAddress}
                                                    placeholder={localized.EmailAddress}
                                                    name="email"
                                                    type="email"
                                                    validate={emailvalidate}
                                                />
                                                <FormGroup className="form-group">
                                                    <Label className="col-form-label">
                                                        {localized.Password}
                                                    </Label>
                                                    <div className="form-input position-relative">
                                                        <Field
                                                            name="password"
                                                            placeholder={"*********"}
                                                            type={togglePassword ? "text" : "password"}
                                                            validate={strongPassword}
                                                        />
                                                        <div
                                                            className="show-hide"
                                                            onClick={() => setTogglePassword(!togglePassword)}
                                                        >
                                                            <span className={togglePassword ? "" : "show"}/>
                                                        </div>
                                                    </div>
                                                </FormGroup>
                                                <FormGroup className="form-group mb-0 text-end">
                                                    <div className="checkbox p-0">
                                                        <Link className="link" to="/forget-password">
                                                            {localized.ForgotPassword}
                                                        </Link>
                                                    </div>
                                                </FormGroup>
                                                <div className="text-end mt-3">
                                                    <Button
                                                        type="submit"
                                                        color={"primary w-100"}
                                                        className={"btn-block"}
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting ? localized.Sigining_in : localized.SignIn}
                                                    </Button>
                                                </div>
                                            </form>
                                        )
                                    }}
                                </Formik>
                                <p className="mt-4 mb-0 text-center">
                                    {localized.new_user}
                                    <Link
                                        className="ms-2"
                                        to={`/signup${getParams("lang") ? "?lang=" + getParams("lang") : ""}`}
                                    > {localized.CreateAccount}
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};
export default Login;
